module.exports = __webpack_public_path__ + "img/p29185.096e37b3.jpg";